import gql from 'graphql-tag';

const STORE_TRAINERTAG_MSB = gql`
  mutation StoreTrainerTags($tags: [StoreTrainerTag!]!) {
    storeTrainerTags(
      tags: $tags
    ) {
      group_id
      tagged_word {
        id
        message_id
        lesson_id
        word
        deleted_at
      }
      tags {
        id
        teacher_tagged_word_id
        vocabulary_tag_id
        name
        description
      }
    }
  }
`;

const DELETE_TRAINERTAG_MSB = gql`
  mutation DeleteTags($message_id: Int!, $lesson_id: Int!) {
    deleteTags(
      message_id: $message_id
      lesson_id: $lesson_id
    ) {
      message
      rows_affected
    }
  }
`;

export { STORE_TRAINERTAG_MSB, DELETE_TRAINERTAG_MSB };
